'use client'
import { useLang } from '../../context/LangContext'
import { t, productStreaming } from '../../lib/translations'
import ProductLanding from '../../components/ProductLanding'
import Icon from '../../components/Icon'
import { streamingPlans } from '../../data/plans'

const featureIcons = ['lightning', 'globe', 'server', 'support', 'bell', 'apps', 'check-circle', 'users'] as const

export const customStreamingPlans = [
  {
    name: { en: 'Trial', fa: 'بسته آزمایشی (رایگان)', ar: 'النسخة التجريبية' },
    price: { en: 'Free', fa: 'رایگان', ar: 'مجانًا' },
    popular: false,
    specs: [
      { label: { en: 'Duration', fa: 'بازه زمانی', ar: 'المدة' }, value: { en: '3 Days', fa: '۳ روز', ar: '٣ أيام' } },
      { label: { en: 'Concurrent Streams', fa: 'استریم همزمان', ar: 'بث متزامن' }, value: { en: '1 Stream', fa: '۱ استریم', ar: '١ بث' } },
      { label: { en: 'Restreams', fa: 'ری‌استریم', ar: 'إعادة البث' }, value: { en: 'None', fa: 'بدون ری‌استریم', ar: 'لا يوجد' } },
      { label: { en: 'Max Resolution', fa: 'حداکثر رزولوشن', ar: 'أقصى دقة' }, value: { en: 'HD', fa: 'HD', ar: 'HD' } },
      { label: { en: 'Max FPS', fa: 'حداکثر نرخ فریم', ar: 'أقصى FPS' }, value: { en: '25', fa: '۲۵', ar: '٢٥' } },
      { label: { en: 'Supported Codec', fa: 'کدک پشتیبانی شده', ar: 'الترميز المدعوم' }, value: { en: 'H264', fa: 'H264', ar: 'H264' } },
      { label: { en: 'ABR Support', fa: 'پشتیبانی از ABR', ar: 'دعم ABR' }, value: { en: 'No', fa: 'ندارد', ar: 'لا' } },
      { label: { en: 'Max Bitrate', fa: 'حداکثر نرخ بیت', ar: 'أقصى معدل بت' }, value: { en: '1200kbps', fa: '1200kbps', ar: '1200kbps' } },
      { label: { en: 'Bandwidth', fa: 'حجم پهنای باند', ar: 'عرض النطاق الترددي' }, value: { en: '10 GB', fa: '۱۰ گیگابایت', ar: '١٠ جيجابايت' } },
    ]
  },
  {
    name: { en: 'Starter', fa: 'بسته شروع (حمایتی)', ar: 'البداية' },
    price: { en: '870,000', fa: '۸۷۰,۰۰۰', ar: '٨٧٠,٠٠٠' },
    period: { en: '/month', fa: 'تومان', ar: 'تومان' },
    popular: false,
    specs: [
      { label: { en: 'Duration', fa: 'بازه زمانی', ar: 'المدة' }, value: { en: '30 Days', fa: '۳۰ روز', ar: '٣٠ يومًا' } },
      { label: { en: 'Concurrent Streams', fa: 'استریم همزمان', ar: 'بث متزامن' }, value: { en: '1 Stream', fa: '۱ استریم', ar: '١ بث' } },
      { label: { en: 'Restreams', fa: 'ری‌استریم', ar: 'إعادة البث' }, value: { en: '1 Free', fa: '۱ ری‌استریم هدیه', ar: '١ مجاني' } },
      { label: { en: 'Max Resolution', fa: 'حداکثر رزولوشن', ar: 'أقصى دقة' }, value: { en: 'HD', fa: 'HD', ar: 'HD' } },
      { label: { en: 'Max FPS', fa: 'حداکثر نرخ فریم', ar: 'أقصى FPS' }, value: { en: '30', fa: '۳۰', ar: '٣٠' } },
      { label: { en: 'Supported Codec', fa: 'کدک پشتیبانی شده', ar: 'الترميز المدعوم' }, value: { en: 'H264', fa: 'H264', ar: 'H264' } },
      { label: { en: 'ABR Support', fa: 'پشتیبانی از ABR', ar: 'دعم ABR' }, value: { en: 'Yes', fa: 'دارد', ar: 'نعم' } },
      { label: { en: 'Max Bitrate', fa: 'حداکثر نرخ بیت', ar: 'أقصى معدل بت' }, value: { en: '2mbps', fa: '2mbps', ar: '2mbps' } },
      { label: { en: 'Bandwidth', fa: 'حجم پهنای باند', ar: 'عرض النطاق الترددي' }, value: { en: '50 GB', fa: '۵۰ گیگابایت', ar: '٥٠ جيجابايت' } },
    ]
  },
  {
    name: { en: 'Content Creator', fa: 'بسته تولیدکننده محتوا', ar: 'صانع المحتوى' },
    price: { en: '2,570,000', fa: '۲,۵۷۰,۰۰۰', ar: '٢,٥٧٠,٠٠٠' },
    period: { en: '/month', fa: 'تومان', ar: 'تومان' },
    popular: true,
    specs: [
      { label: { en: 'Duration', fa: 'بازه زمانی', ar: 'المدة' }, value: { en: '30 Days', fa: '۳۰ روز', ar: '٣٠ يومًا' } },
      { label: { en: 'Concurrent Streams', fa: 'استریم همزمان', ar: 'بث متزامن' }, value: { en: '3 Streams', fa: '۳ استریم', ar: '٣ بث' } },
      { label: { en: 'Restreams', fa: 'ری‌استریم', ar: 'إعادة البث' }, value: { en: '3', fa: '۳ ری‌استریم', ar: '٣' } },
      { label: { en: 'Max Resolution', fa: 'حداکثر رزولوشن', ar: 'أقصى دقة' }, value: { en: 'FullHD', fa: 'FullHD', ar: 'FullHD' } },
      { label: { en: 'Max FPS', fa: 'حداکثر نرخ فریم', ar: 'أقصى FPS' }, value: { en: '30', fa: '۳۰', ar: '٣٠' } },
      { label: { en: 'Supported Codec', fa: 'کدک پشتیبانی شده', ar: 'الترميز المدعوم' }, value: { en: 'H264', fa: 'H264', ar: 'H264' } },
      { label: { en: 'ABR Support', fa: 'پشتیبانی از ABR', ar: 'دعم ABR' }, value: { en: 'Yes', fa: 'دارد', ar: 'نعم' } },
      { label: { en: 'Max Bitrate', fa: 'حداکثر نرخ بیت', ar: 'أقصى معدل بت' }, value: { en: '8mbps', fa: '8mbps', ar: '8mbps' } },
      { label: { en: 'Bandwidth', fa: 'حجم پهنای باند', ar: 'عرض النطاق الترددي' }, value: { en: '500 GB', fa: '۵۰۰ گیگابایت', ar: '٥٠٠ جيجابايت' } },
    ]
  },
  {
    name: { en: 'Professional', fa: 'بسته حرفه‌ای', ar: 'احترافي' },
    price: { en: '12,770,000', fa: '۱۲,۷۷۰,۰۰۰', ar: '١٢,٧٧٠,٠٠٠' },
    period: { en: '/month', fa: 'تومان', ar: 'تومان' },
    popular: false,
    specs: [
      { label: { en: 'Duration', fa: 'بازه زمانی', ar: 'المدة' }, value: { en: '30 Days', fa: '۳۰ روز', ar: '٣٠ يومًا' } },
      { label: { en: 'Concurrent Streams', fa: 'استریم همزمان', ar: 'بث متزامن' }, value: { en: '10 Streams', fa: '۱۰ استریم', ar: '١٠ بث' } },
      { label: { en: 'Restreams', fa: 'ری‌استریم', ar: 'إعادة البث' }, value: { en: '5', fa: '۵ ری‌استریم', ar: '٥' } },
      { label: { en: 'Max Resolution', fa: 'حداکثر رزولوشن', ar: 'أقصى دقة' }, value: { en: 'FullHD', fa: 'FullHD', ar: 'FullHD' } },
      { label: { en: 'Max FPS', fa: 'حداکثر نرخ فریم', ar: 'أقصى FPS' }, value: { en: '60', fa: '۶۰', ar: '٦٠' } },
      { label: { en: 'Supported Codec', fa: 'کدک پشتیبانی شده', ar: 'الترميز المدعوم' }, value: { en: 'H264', fa: 'H264', ar: 'H264' } },
      { label: { en: 'ABR Support', fa: 'پشتیبانی از ABR', ar: 'دعم ABR' }, value: { en: 'Yes', fa: 'دارد', ar: 'نعم' } },
      { label: { en: 'Max Bitrate', fa: 'حداکثر نرخ بیت', ar: 'أقصى معدل بت' }, value: { en: '15mbps', fa: '15mbps', ar: '15mbps' } },
      { label: { en: 'Bandwidth', fa: 'حجم پهنای باند', ar: 'عرض النطاق الترددي' }, value: { en: '2 TB', fa: '۲ ترابایت', ar: '٢ تيرابايت' } },
    ]
  },
  {
    name: { en: 'Enterprise', fa: 'بسته سازمانی', ar: 'مؤسسي' },
    price: { en: 'Contact Sales', fa: 'تماس بگیرید', ar: 'اتصل بالمبيعات' },
    period: { en: '', fa: '', ar: '' },
    popular: false,
    specs: [
      { label: { en: 'Duration', fa: 'بازه زمانی', ar: 'المدة' }, value: { en: 'Custom', fa: 'بازه زمانی موردنیاز', ar: 'مخصص' } },
      { label: { en: 'Concurrent Streams', fa: 'استریم همزمان', ar: 'بث متزامن' }, value: { en: '+50 Streams', fa: '+۵۰ استریم', ar: '+٥٠ بث' } },
      { label: { en: 'Restreams', fa: 'ری‌استریم', ar: 'إعادة البث' }, value: { en: '+50', fa: '+۵۰ ری‌استریم', ar: '+٥٠' } },
      { label: { en: 'Max Resolution', fa: 'حداکثر رزولوشن', ar: 'أقصى دقة' }, value: { en: '4K', fa: '4K', ar: '4K' } },
      { label: { en: 'Max FPS', fa: 'حداکثر نرخ فریم', ar: 'أقصى FPS' }, value: { en: '60', fa: '۶۰', ar: '٦٠' } },
      { label: { en: 'Supported Codec', fa: 'کدک پشتیبانی شده', ar: 'الترميز المدعوم' }, value: { en: 'H264 & H265', fa: 'H264 و H265', ar: 'H264 و H265' } },
      { label: { en: 'ABR Support', fa: 'پشتیبانی از ABR', ar: 'دعم ABR' }, value: { en: 'Yes', fa: 'دارد', ar: 'نعم' } },
      { label: { en: 'Max Bitrate', fa: 'حداکثر نرخ بیت', ar: 'أقصى معدل بت' }, value: { en: '+20mbps', fa: '+20mbps', ar: '+20mbps' } },
      { label: { en: 'Bandwidth', fa: 'حجم پهنای باند', ar: 'عرض النطاق الترددي' }, value: { en: 'Unlimited', fa: 'نامحدود', ar: 'غير محدود' } },
    ]
  }
]

export default function StreamingPage() {
  const lang = useLang()
  const features = productStreaming.features.map((f, i) => ({
    title: t(lang, f.title),
    description: t(lang, f.description),
    icon: <Icon name={featureIcons[i % featureIcons.length]} className="w-6 h-6" strokeWidth={1.5} />,
  }))
  const benefits = productStreaming.benefits.map((b) => ({ title: t(lang, b.title), desc: t(lang, b.desc) }))

  return (
    <ProductLanding
      id="streaming"
      title={t(lang, productStreaming.title)}
      subtitle={t(lang, productStreaming.subtitle)}
      description={t(lang, productStreaming.description)}
      heroBg="bg-gradient-to-b from-[#ec4899]/5 via-transparent to-transparent"
      heroGlow="bg-[#f472b6]/10"
      features={features}
      featuresHeading={productStreaming.featuresHeading ? t(lang, productStreaming.featuresHeading) : undefined}
      featuresDesc={productStreaming.featuresDesc ? t(lang, productStreaming.featuresDesc) : undefined}
      benefits={benefits}
    >
      <section className="relative py-24 sm:py-32 overflow-hidden">
        <div className="absolute inset-0 dot-pattern pointer-events-none" />
        <div
          className="absolute top-1/3 right-0 w-96 h-96 rounded-full blur-[160px] pointer-events-none opacity-20"
          style={{ background: 'radial-gradient(circle, #ec4899, transparent)' }}
        />

        <div className="relative max-w-7xl mx-auto px-8 sm:px-8 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-white mb-4">{lang === 'fa' ? 'پلن‌های استریمینگ' : 'Streaming Plans'}</h2>
            <p className="text-[#94a3b8]">{lang === 'fa' ? 'بهترین پلن را برای نیازهای رسانه‌ای خود انتخاب کنید.' : 'Choose the best plan for your media needs.'}</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
            {customStreamingPlans.map((plan, i) => (
              <div
                key={i}
                className={`group relative h-full rounded-2xl border transition-all duration-500 flex flex-col ${
                  plan.popular
                    ? 'bg-gradient-to-b from-[#ec4899]/10 to-[#f472b6]/5 border-[#ec4899]/30 shadow-2xl shadow-[#ec4899]/10 hover:border-[#ec4899]/60 hover:shadow-[#ec4899]/20'
                    : 'bg-white/[0.02] border-white/[0.06] hover:border-white/[0.12]'
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-gradient-to-r from-[#ec4899] to-[#f472b6] text-xs font-semibold text-white">
                    {lang === 'fa' ? 'پرطرفدار' : 'Popular'}
                  </div>
                )}
                <div className="p-5 flex flex-col h-full">
                  <h3 className="text-lg font-semibold text-white mb-4 text-center">{t(lang, plan.name)}</h3>
                  <div className="flex items-baseline justify-center gap-1.5 mb-6 border-b border-white/[0.06] pb-6 min-h-[60px]">
                    <span className="text-2xl font-bold text-white">{t(lang, plan.price)}</span>
                    <span className="text-sm text-[#64748b]">{plan.period ? t(lang, plan.period) : '\u00A0'}</span>
                  </div>
                  <div className="space-y-2 flex-1 mb-6">
                    {plan.specs.map((spec, j) => (
                      <div key={j} className="flex items-center justify-between gap-2 text-xs border-b border-white/[0.03] pb-2 last:border-0 last:pb-0">
                        <span className="text-[#64748b] whitespace-nowrap">{t(lang, spec.label)}</span>
                        <span className="text-[#e2e8f0] font-medium text-right line-clamp-1" title={t(lang, spec.value)}>{t(lang, spec.value)}</span>
                      </div>
                    ))}
                  </div>
                  <a
                    href={`/${lang}/contact`}
                    className={`block w-full py-2.5 rounded-xl text-sm font-medium text-center transition-all duration-500 mt-auto ${
                      plan.popular
                        ? 'bg-gradient-to-r from-[#ec4899] to-[#f472b6] hover:from-[#f472b6] hover:to-[#ec4899] text-white shadow-lg shadow-[#ec4899]/20'
                        : 'text-[#94a3b8] border border-white/[0.08] hover:bg-white/[0.04]'
                    }`}
                  >
                    {lang === 'fa' ? 'ثبت سفارش' : 'Order Now'}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </ProductLanding>
  )
}
